import { hasUnsavedFormChanges } from "../../../../common/formStateDirty";

export type AffinityProgramDraft = {
  companyName: string;
  description: string;
  logo: string;
  startDate: string;
  title: string;
  redirectLink: string;
};

type AffinityProgramDirtyComparisonInput = {
  baseline: AffinityProgramDraft;
  current: AffinityProgramDraft;
};

export const hasUnsavedAffinityProgramDraftChanges = ({
  baseline,
  current,
}: AffinityProgramDirtyComparisonInput): boolean =>
  hasUnsavedFormChanges({ baseline, current });
